import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { NgIf } from '@angular/common';
import * as model from "../../../../models";

@Component({
	selector: 'ticket-quota',
	templateUrl: "./ticket-quota.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./ticket-quota.scss")]
})
export class TicketQuota {
	@Input() private ticketQuotaCollection: model.TicketQuota[]
	@Input() private selectedTicketQuota: model.TicketQuota
	@Input() private displayButtons: boolean

	@Output() selectedTicketQuotaChanged: EventEmitter<model.TicketQuota> = new EventEmitter<model.TicketQuota>();
	@Output() createTicketQuotaClicked = new EventEmitter<void>();
	@Output() updateTicketQuota: EventEmitter<model.TicketQuota> = new EventEmitter<model.TicketQuota>();
	@Output() removeTicketQuota: EventEmitter<model.TicketQuota> = new EventEmitter<model.TicketQuota>();


	onChange(selectedTicketQuotaUuid: string) {
		if (selectedTicketQuotaUuid) {
			this.selectedTicketQuota = this.ticketQuotaCollection.find(element => element.uuid === selectedTicketQuotaUuid)
			this.selectedTicketQuotaChanged.emit(this.selectedTicketQuota)
		}
	}

	protected updateTicketQuotaClicked() {
		if (this.selectedTicketQuota) {
			this.updateTicketQuota.emit(this.selectedTicketQuota)
		}
	}

	protected removeTicketQuotaClicked() {
		if (this.selectedTicketQuota) {
			this.removeTicketQuota.emit(this.selectedTicketQuota)
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/ticket-quota-collection/ticket-quota/ticket-qouta.component.ts